<template>
  <b-section-loader :loading="$loading.isLoading('registrationJournalSingle')">
    <v-card border>
      <v-card-text>
        <b-form hide-action-buttons @submit="updateJournal">
          <div class="d-flex align-center justify-space-between ga-3">
            <div class="d-flex align-center ga-3">
              <div class="icon--blue">
                <v-icon icon="mdi-file-document-outline" size="23"></v-icon>
              </div>

              <div>
                <div class="font-weight-bold font-size-18">
                  {{ journalSource.name }}
                </div>
                <div class="d-flex ga-2">
                  <v-chip
                    color="grey"
                    density="compact"
                    rounded="lg"
                    size="small">
                    <span
                      class="font-size-10 font-weight-bold text-grey-darken-2">
                      {{ journalSource.code }}
                    </span>
                  </v-chip>

                  <div class="text-disabled">
                    Маска:
                    {{
                      journalSource.numberMask &&
                      journalSource.numberMaskPreview
                        ? 'наявна'
                        : 'відсутня'
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-center ga-3">
              <v-chip
                v-if="journalSource.isActive"
                color="success"
                @click="toggleActive">
                <b>Активний</b>
              </v-chip>
              <v-chip
                v-if="!journalSource.isActive"
                color="error"
                @click="toggleActive">
                <b>Неактивний</b>
              </v-chip>

              <v-btn
                v-show="journalCredentials.$hasChanges"
                :loading="$loading.isLoading('registrationJournalUpdate')"
                type="submit">
                <v-icon class="mr-1" color="white">mdi-check</v-icon>
                Зберегти
              </v-btn>
            </div>
          </div>
          <v-divider class="mt-5 mb-4"></v-divider>

          <registration-journal-tabs></registration-journal-tabs>

          <router-view></router-view>
        </b-form>
      </v-card-text>
    </v-card>
  </b-section-loader>
</template>

<script lang="ts">
import { BForm, BSectionLoader } from 'best-modules/components'
import { initRegistrationJournal } from './registrationJournal'
import RegistrationJournalTabs from './components/Tabs.vue'

export default {
  name: 'RegistrationJournalSingle',
  components: { BForm, BSectionLoader, RegistrationJournalTabs },
  setup() {
    return {
      ...initRegistrationJournal(),
    }
  },
}
</script>
